<finder-list-drawer
    class="drawer"
    #drawer
    [(displayedState)]="displayed"
    [hideCaret]="shrinkButtons"
    [sourceElement]="sourceElement"
    closeOnClickOutside="true"
    (displayedStateChange)="changed($event)">
        <finder-all-filters
            [allFilters]="filters"
            [doneLabel]="labels.done"
            [showMoreLabel]="labels.showMore"
            [useHeightFilter]="useHeightFilter"
            [heightLabel]="labels.height">
        </finder-all-filters>
</finder-list-drawer>
